module.exports = __webpack_public_path__ + "img/exa4.0e2cdfc9.png";